import { Component, input } from '@angular/core';

/**
 * The brand button on a native `<button>` or `<a>`: display face, capitals, sharp corners.
 * `primary` is the one main action of a screen; `ghost` a quiet secondary action; `danger`
 * and `danger-ghost` destructive actions; `inverse` the light button on a dark card.
 * Width and alignment belong to the parent's stylesheet.
 */
@Component({
  selector: 'button[ppcButton], a[ppcButton]',
  template: '<ng-content />',
  styleUrl: './button.css',
  host: {
    '[attr.data-variant]': 'variant()',
    '[attr.data-size]': 'size()',
  },
})
export class PpcButton {

  readonly variant = input<'primary' | 'ghost' | 'danger' | 'danger-ghost' | 'inverse'>('primary');
  readonly size = input<'sm' | 'md' | 'lg'>('md');

}
